import axios from "axios";
import { baseUrl } from "../util";

const getConfig = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem("access_token")}`,
    "Content-Type": "application/json",
  },
});

export const teamsService = {
  getTeams: async (effortId) => {
    try {
      const response = await axios.get(
        `${baseUrl}/api/business/efforts/${effortId}/teams/`,
        getConfig()
      );
      return response.data.data;
    } catch (error) {
      console.error("Error fetching teams:", error);
      throw error;
    }
  },

  createTeam: async (effortId, teamData) => {
    try {
      const response = await axios.post(
        `${baseUrl}/api/business/efforts/${effortId}/teams/`,
        teamData,
        getConfig()
      );
      return response.data.data;
    } catch (error) {
      console.error("Error creating team:", error);
      throw error;
    }
  },

  updateTeam: async (effortId, teamId, teamData) => {
    try {
      const response = await axios.put(
        `${baseUrl}/api/business/efforts/${effortId}/teams/${teamId}/`,
        teamData,
        getConfig()
      );
      return response.data.data;
    } catch (error) {
      console.error("Error updating team:", error);
      throw error;
    }
  },

  deleteTeam: async (effortId, teamId) => {
    try {
      const response = await axios.delete(
        `${baseUrl}/api/business/efforts/${effortId}/teams/${teamId}/`,
        getConfig()
      );
      return response.status === 204;
    } catch (error) {
      console.error("Error deleting team:", error);
      throw error;
    }
  },
};
